import { cn } from '@/platform/lib/utils';
import { MenuButton as HeadlessMenuButton } from '@headlessui/react';

const MenuButton = ({ className, ...props }) => (
    <HeadlessMenuButton
        className={cn('inline-flex items-center outline-hidden', className)}
        {...props}
    />
);

export default MenuButton;
